import { render, staticRenderFns } from "./6-gang-common.vue?vue&type=template&id=7e0e7c02&scoped=true&"
import script from "./6-gang-common.vue?vue&type=script&lang=js&"
export * from "./6-gang-common.vue?vue&type=script&lang=js&"
import style0 from "./6-gang-common.vue?vue&type=style&index=0&id=7e0e7c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e7c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0e7c02')) {
      api.createRecord('7e0e7c02', component.options)
    } else {
      api.reload('7e0e7c02', component.options)
    }
    module.hot.accept("./6-gang-common.vue?vue&type=template&id=7e0e7c02&scoped=true&", function () {
      api.rerender('7e0e7c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-gang-common.vue"
export default component.exports